/** @jsxRuntime automatic */
/** @jsxImportSource react */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './RandomMonkeyApp.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
